import { useCallback, useEffect } from 'react';
import { InsighttNotificationType } from './types';
import { Text } from '@rapid-recovery-agency-inc/sloth-ui-web';

const Notification = (props: InsighttNotificationType) => {
  const {
    title,
    link,
    linkMessage,
    message,
    onClick,
    onRequestHide,
    customClassName = '',
    type = 'info',
    timeOut = 5000,
  } = props;

  const className = `notification notification-${type} ${customClassName}`;
  const titleRender = title ? <h4 className="title">{title}</h4> : null;

  const requestHide = useCallback(() => {
    if (onRequestHide) onRequestHide();
  }, [onRequestHide]);

  const handleClick = () => {
    if (onClick) onClick();
    requestHide();
  };

  useEffect(() => {
    if (timeOut !== 0) {
      const timer = setTimeout(() => {
        requestHide();
      }, timeOut);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [requestHide, timeOut]);

  return (
    <div className={className} onClick={handleClick}>
      <div className="notification-message" role="alert">
        <Text type="heading9" color="WHITE">
          {titleRender}
        </Text>
        <div className="message">
          <Text type="paragraph3" color="WHITE">
            {message}
          </Text>
        </div>
        {link && (
          <a
            href={link}
            style={{
              color: '#fff',
              marginTop: 4,
              display: 'inline-block',
              textDecoration: 'underline',
            }}
          >
            {linkMessage}
          </a>
        )}
      </div>
    </div>
  );
};

export default Notification;
